<template>
    <div id="dashboard-page" class="mb-5">
        <b-row class="mb-5 mt-2">
          <b-col md="5" id="colored">
            <b-card no-body class="top-card">
              <b-row>
                <b-col md="6" id="totalvehicle-menu">
                  <b-button variant="light" @click="getAllVehicle"><p id="totalvehicle-text">Total Vehicle <span id="totalvehicle-value">{{totalVehicle}}</span></p></b-button>
                </b-col>
                <b-col md="3" class="text-center" style="background-color:#f8f9fa!important; border-radius:10px!important;" id="lineon">
                    <b-button variant="light" @click="getAvailable">
                        <p class="topmenu-available" style="font-size:12px;">Available</p>
                        <p class="topmenu" style="color:#f3b700!important; font-weight: bold!important;">{{available}}</p>
                    </b-button>
                </b-col>
                <b-col md="3" class="text-center" style="background-color:#f8f9fa!important; border-radius:10px!important;" id="lineon">
                    <b-button variant="light" @click="getOnTheRoad">
                        <p class="topmenu-available" style="font-size:12px;">On The Road</p>
                        <p class="topmenu" style="color:#f3b700!important; font-weight: bold!important;">{{onTheRoad}}</p>
                    </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col md="7" id="colored-type">
            <b-card no-body class="card-vehicle">
              <b-row>
                <b-col md="1">
                </b-col>
                <b-col md="2">
                    <router-link to="vehicle/road-tax">
                    <div class="alertmenu alertmenu-roadtax text-center">
                        <p id="text-type">Road Tax</p>
                        <p id="value-type" style="color:#1976D2!important;">{{roadTax}}</p>
                    </div>
                    </router-link>
                </b-col>
                <b-col md="2">
                    <router-link to="/vehicle/services">
                    <div class="alertmenu alertmenu-service text-center">
                        <p id="text-type">Service</p>
                        <p id="value-type" style="color:#512DA8!important;">{{services}}</p>
                    </div>
                    </router-link>
                </b-col>
                <b-col md="2">
                    <router-link to="/vehicle/penalty">
                    <div class="alertmenu alertmenu-penalty text-center">
                        <p id="text-type">Penalty</p>
                        <p id="value-type" style="color:#F57C00!important;">{{penalty}}</p>
                    </div>
                    </router-link>
                </b-col>
                <b-col md="2">
                    <router-link to="/vehicle/repair">
                    <div class="alertmenu alertmenu-repair text-center">
                        <p id="text-type">Repair</p>
                        <p id="value-type" style="color:#689F38!important;">{{repair}}</p>
                    </div>
                    </router-link>
                </b-col>
                <b-col md="2">
                    <router-link to="/vehicle/insurance">
                    <div class="alertmenu alertmenu-insurance text-center">
                        <p id="text-insurance">Insurance</p>
                        <p id="value-type" style="color:#26A69A!important;">{{insurance}}</p>
                    </div>
                    </router-link>
                </b-col>
                <b-col md="1">
                </b-col>
                <!-- <b-col md="2">
                    <router-link to="/vehicle/insurance">
                    <p>Insurance</p>
                    <span class="text-vehicle-count">{{insurance}}</span></router-link>
                </b-col> -->
              </b-row>
            </b-card>
          </b-col>

          <b-col md="12" class="mt-4">
            <b-card>
              <b-row>
                <b-col md="6">
                    <h3>Vehicle Dashboard</h3>
                    <b-breadcrumb>
                        <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                        <b-breadcrumb-item active>{{ $route.name }} Dashboard</b-breadcrumb-item>
                    </b-breadcrumb>
                </b-col>
                <b-col md="6 mt-3 float-right">
                    <b-button variant="primary" class="mb-2 float-right btn-custom" :to="'vehicle/create'"><font-awesome-icon icon="plus"/></b-button>
                </b-col>
              </b-row>
              <div class="border-bottom mb-3" />
              <b-form v-on:submit.prevent="doFilter">
                <b-row>
                    <b-col md="12">
                        <div v-if="$store.getters['account/accountData'].roleDownStream[0].role === 'ADMIN'">
                            <b-row class="mt-1 mb-2">
                                <b-col md="2 mb-2">
                                    <b-form-input :placeholder="'Plate Number'" v-model="tableFilter.plate" customQueryParamName="search" />
                                </b-col>
                                <b-col md="2 mb-2">
                                    <b-form-select v-model="tableFilter.category" :options="categoryList" />
                                </b-col>
                                <b-col md="2 mb-2">
                                    <b-form-select v-model="tableFilter.company" :options="companyList" />
                                </b-col>
                                <b-col md="2 mb-2">
                                    <b-form-select v-model="tableFilter.branch" :options="branchList" />
                                </b-col>
                                <b-col md="4">
                                    <button type="submit" class="mb-2 ml-2 btn btn-primary float-right" id="btn-search"><font-awesome-icon icon="search"/> Filter</button>
                                    <button @click="clearFilter()" class="ml-0 btn btn-outline-primary float-right" id="btn-search"><font-awesome-icon icon="times-circle"/> Clear Filter</button>
                                </b-col>
                                <b-button variant="light" style="margin-left:-70px!important;" disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
                                </b-button>
                            </b-row>
                        </div>
                        <div v-else>
                            <b-row class="mt-1 mb-3">
                                <b-col md="4">
                                    <b-form-input :placeholder="'Plate Number'" v-model="tableFilter.plate" customQueryParamName="search" />
                                </b-col>
                                <b-col md="4">
                                    <b-form-select v-model="tableFilter.category" :options="categoryList" />
                                </b-col>
                                <b-col md="4">
                                    <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search"><font-awesome-icon icon="search"/> Filter</button>
                                    <button @click="clearFilter()" class="ml-0 btn btn-outline-primary float-right" id="btn-search"><font-awesome-icon icon="times-circle"/> Clear Filter</button>
                                </b-col>
                                <b-button variant="light" style="margin-left:-70px!important;" disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
                                </b-button>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
              </b-form>
              <paginated-table ref="dataTable" :can-edit="true" :can-delete="false" :can-approve="false" :can-reject="false" :data-url="apiUrl.vehicle" :data-key="dataKey" :data-columns="columns" :data-params="['merk', 'plate', 'category', 'company_uuid', 'branch_uuid', 'status']">
              </paginated-table> 
            </b-card>
          </b-col>
        </b-row>
    </div>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        name: 'vehicle',
        components: {
          PaginatedTable
        },
        data () {
            return {
                isLoadingBranch: false,
                dataKey: 'vehicles',
                apiUrl: {
                    vehicle: window.AppConfig.apiUrl + 'vehicle?limit=10',
                    vehicleStats: window.AppConfig.apiUrl + 'vehicle-stats',
                    vehicleReportStats: window.AppConfig.apiUrl + 'vehicle-report-stats'
                },
                columns: [
                    {
                        key: 'plate',
                        sortable: true
                    },
                    {
                        key: 'model',
                        sortable: true
                    },
                    {
                        key: 'category',
                        sortable: true
                    },
                    {
                        key: 'company',
                        sortable: true
                    },
                    {
                        key: 'branch',
                        sortable: true
                    },
                    {
                        key: 'requestedByVehicle',
                        label: 'Driven By',
                        sortable: false
                    },
                    {
                        key: 'statusVehicle',
                        label: 'Status',
                        sortable: false
                    },
                    {
                        key: 'actions',
                        label: '',
                        sortable: false
                    }
                ],
                tableFilter: {
                    company_uuid: this.$route.query.company_uuid,
                    company: null,
                    branch_uuid: this.$route.query.branch_uuid,
                    branch: null,
                    category_uuid: this.$route.query.category_uuid,
                    category: null,
                    merk: this.$route.query.merk,
                    plate: this.$route.query.plate,
                    status: this.$route.query.status
                },
                companyList: [
                    {
                        value: null,
                        text: 'Company'
                    }
                ],
                branchList: [
                    {
                        value: null,
                        text: 'Branch'
                    }
                ],
                categoryList: [
                    {
                        value: null,
                        text: 'Category'
                    }
                ],                
                available: null,
                status: {
                  onTheRoad: "0",
                  available: "1",
                },
                onTheRoad: null,
                totalVehicle: null,
                roadTax: null,
                services: null,
                penalty: null,
                repair: null,
                insurance: null,
                start_due_date_roadtax: null,
                end_due_date_roadtax: null,
                start_due_date_insurance: null,
                end_due_date_insurance: null
            }
        },
        watch: {
            'tableFilter.company' (value) {
                this.getBranch(value)
            }
        },
        mounted () {
            this.getCompany()
            // this.getBranch()
            this.getCategory()
            this.getVehicleStats()
        },
        methods: {
            doFilter () {
                this.tableFilter.plate = this.tableFilter.plate
                this.tableFilter.merk = this.tableFilter.merk
                this.tableFilter.company_uuid = this.tableFilter.company
                this.tableFilter.branch_uuid = this.tableFilter.branch
                this.tableFilter.category_uuid = this.tableFilter.category
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            clearFilter () {
                this.tableFilter.company = null
                this.tableFilter.branch = null
                this.tableFilter.category = null
                this.tableFilter.plate = null
                this.tableFilter.date = null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            getCategory () {
                this.$http.get(window.AppConfig.apiUrl + 'vehicle-category?limit=10000').then(resp => {
                    resp.data._embedded.vehicleCategory.forEach(data => {
                        this.categoryList.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            getVehicleStats () {
                this.$http.get(this.apiUrl.vehicleStats).then(resp => {
                  this.available = resp.data.available
                  this.onTheRoad = resp.data.onTheRoad
                  this.roadTax = resp.data.roadTax.total
                  this.services = resp.data.services
                  this.penalty = resp.data.penalty
                  this.repair = resp.data.repair
                  this.insurance = resp.data.insurance.total
                  this.totalVehicle = resp.data.totalVehicle
                  this.start_due_date_insurance = resp.data.insurance.startDate
                  this.end_due_date_insurance = resp.data.insurance.endDate
                  this.start_due_date_roadtax = resp.data.roadTax.startDate
                  this.end_due_date_roadtax = resp.data.roadTax.endDate
                })
            },
            // getRoadTax () {
            //     let url = window.AppConfig.apiUrl + 'vehicle/road-tax?'
            //     url += 'start_due_date=' + this.$moment(this.startDate).format('YYYY-MM-DD') + '&end_due_date=' + this.$moment(this.endDate).format('YYYY-MM-DD')

            //     window.open(url)
            // },
            getCompany () {
                this.$http.get(window.AppConfig.apiUrl + 'company?limit=10000').then(resp => {
                    resp.data._embedded.company.forEach(data => {
                        this.companyList.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            getBranch (companyUuid = null) {
              this.isLoadingBranch = true
              if (companyUuid != null && this.tableFilter.company != null) {
                //   this.doFilter()
                  this.tableFilter.branch_uuid = this.tableFilter.branch
                  this.tableFilter.branch = null
                  this.tableFilter.company_uuid = this.tableFilter.company
              } else {
                //   this.doFilter()
                  this.tableFilter.branch = null
                  this.tableFilter.company = null
              }
              this.$http.get(window.AppConfig.apiUrl + 'branch?limit=100&company_uuid=' + companyUuid + '&is_active=1').then(response => {
                this.branchList = []
                this.isLoadingBranch = false
                response.data._embedded.branch.forEach(data => {
                    this.branchList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              }).catch(error => {
                  window.consoleLog(error)
                  this.isLoadingBranch = false
              })
            },
            getAvailable () {
                this.tableFilter.status = this.status.available
                this.doFilter()
            },
            getOnTheRoad () {
                this.tableFilter.status = this.status.onTheRoad
                this.doFilter()
            },
            getAllVehicle () {
                this.tableFilter.status = ""
                this.doFilter()
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('DD MMM YYYY hh:mm a')
                } else {
                    return '-'
                }
            },
            getStatusColor (val) {
                switch (parseInt(val)) {
                case 0:
                    return 'danger'
                    break
                case 1:
                    return 'success'
                    break
                }
            },
            getStatusName (val) {
                switch (parseInt(val)) {
                case 0:
                    return 'Not Available'
                    break
                case 1:
                    return 'Available'
                    break
                }
            }
        }
    }
    
</script>